import { Environment } from './environment.model';

export const ENVIRONMENT_PLACEHOLDER: Environment = {
  production: true,
  name: '{ENV_NAME_REPLACE_ME}',
  release: '{RELEASE_REPLACE_ME}',
  staticFilesHost: '{STATIC_FILES_HOST_REPLACE_ME}',
  baseUrlApi: '{BASE_URL_API_REPLACE_ME}',
  pshEmbedUrl: '{PSH_EMBED_URL_REPLACE_ME}',
  // public identifier for the Transifex project
  transifexToken: '{TRANSIFEX_PROJECT_TOKEN_REPLACE_ME}',
  // public HubSpot Portal ID
  hubspotPortalId: '{HUBSPOT_PORTAL_ID_REPLACE_ME}',
  // public Mixpanel ID
  mixpanelId: '{MIXPANEL_ID_REPLACE_ME}',
};
